import React from "react"
import tw, { styled } from "twin.macro"
import ResponsiveVideoEmbed from "./helpers/ResponsiveVideoEmbed.jsx"

const Container = tw.div`relative`
const Content = tw.div`max-w-screen-xl mx-auto my-6 lg:my-12 `
const Column = tw.div`items-center  md:h-auto  lg:px-32`

const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
  padding-bottom: 56.25% !important;
  padding-top: 0px !important;
  ${tw`rounded`}
  iframe {
    ${tw`rounded bg-black shadow-xl`}
  }
`

export default () => {
  return (
    <Container>
      <Content>
        <Column>
          <StyledResponsiveVideoEmbed
            url="https://www.youtube.com/embed/yEH9zD0Kxmw"
            background="transparent"
          />
        </Column>
      </Content>
    </Container>
  )
}
